
import React from 'react';

interface OptimizedFadeInProps {
  children: React.ReactNode;
  className?: string;
}

const OptimizedFadeIn: React.FC<OptimizedFadeInProps> = ({ 
  children, 
  className = "" 
}) => {
  return (
    <div className={`opacity-100 transition-opacity duration-700 ease-in-out ${className}`}>
      {children}
    </div>
  );
};

export default React.memo(OptimizedFadeIn);
